module.exports = __webpack_public_path__ + "img/border-horizontal.c79e2cff.svg";